import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
export function TerroirSection() {
  return <section id="about" className="relative min-h-screen w-full bg-chocolate overflow-hidden flex flex-col lg:flex-row" data-id="element-165">
      {/* Image Side (Desktop: Diagonal Split) */}
      <div className="relative w-full lg:w-[60%] h-[50vh] lg:h-screen order-1 lg:order-2 overflow-hidden" data-id="element-166">
        <div className="absolute inset-0 bg-cover bg-center parallax-bg" style={{
        backgroundImage: 'url("https://assets.modern-commerce.io/Glenlofty%20Project%20Files/A03I5652.jpg")'
      }} data-id="element-167" />
        <div className="absolute inset-0 bg-gradient-to-r from-chocolate/80 via-transparent to-transparent lg:from-chocolate lg:via-transparent" data-id="element-168" />

        {/* Diagonal Clip Path for Desktop */}
        <div className="hidden lg:block absolute inset-0 bg-chocolate" style={{
        clipPath: 'polygon(0 0, 15% 0, 0 100%)'
      }} data-id="element-169"></div>
      </div>

      {/* Content Side */}
      <div className="relative w-full lg:w-[40%] min-h-[50vh] lg:h-screen order-2 lg:order-1 flex items-center justify-center p-8 lg:p-16 z-10" data-id="element-170">
        <div className="bg-charcoal/90 p-8 md:p-12 lg:p-16 shadow-2xl border-l-4 border-gold max-w-xl relative" data-id="element-171">
          {/* Subtle Glow behind box */}
          <div className="absolute -inset-4 bg-gold/5 blur-xl -z-10 rounded-full opacity-50" data-id="element-172"></div>

          <ScrollReveal data-id="element-173">
            <span className="block text-gold text-sm font-light tracking-widest uppercase mb-6" data-id="element-174">
              Our Terroir
            </span>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-175">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-semibold text-white mb-8 leading-tight" data-id="element-176">
              Cool-Climate Pyrenees
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.3} data-id="element-177">
            <div className="w-20 h-1 bg-gold mb-8" data-id="element-178"></div>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-179">
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-8 font-light" data-id="element-180">
              Located approximately 1,000 feet above sea level in the Pyrenees
              foothills, Glenlofty is a true cool-climate site by Australian
              standards. Significant diurnal variation preserves acidity and
              structure. Independent AWRI data identifies Glenlofty as one of
              the coolest sites in the Pyrenees.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.5} data-id="element-181">
            <div className="flex items-center space-x-4 text-gold font-semibold tracking-widest text-sm md:text-base" data-id="element-182">
              <span data-id="element-183">~140 ACRES</span>
              <span className="text-gray-600" data-id="element-184">•</span>
              <span data-id="element-185">1963</span>
              <span className="text-gray-600" data-id="element-186">•</span>
              <span data-id="element-187">ORGANIC</span>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}